import { render } from "./Label.vue?vue&type=template&id=d7c84b9c"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/WD 1/Development/Laravel/pessoalform_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__